import { Inputs } from "2g-form";
import { DayOfWeek } from "b2b/renderers";

export default function resolveInputProps(type) {
  switch (type) {
    case "NUMBER":
      return {
        component: Inputs.Input,
        type: "number"
      };
    case "BOOLEAN":
      return {
        component: Inputs.Checkbox
      };
    case "DAY_OF_WEEK":
      return {
        component: Inputs.AutoComplete,
        minChars: 0,
        staticData: [1, 2, 3, 4, 5, 6, 7],
        rendererOption: DayOfWeek,
        rendererSelected: DayOfWeek
      };
    case "HOUR":
      return {
        component: Inputs.Input,
        type: "number",
        min: 0,
        max: 23,
        step: 1
      };
    case "SMENA_POCET":
      return {
        component: Inputs.Input,
        type: "number",
        min: 0,
        max: 3,
        step: 1
      };
    case "SMENA_HODINY":
      return {
        component: Inputs.Input,
        type: "number",
        min: 0,
        max: 24,
        step: 1
      };
    default:
      return {
        component: Inputs.Input,
        type: "text"
      };
  }
}
